import React from 'react';
import classNames from 'classnames';
import { CIcon, CIcons, CIconSize, CIconColor } from '@/src/components/c-icon/CIcon';
import { CFlex, AlignItems } from '@/src/components/c-flex/CFlex';
import { CTooltip, CTooltipPlacement } from '@/src/components/c-tooltip/CTooltip';
import { CSpacing } from '@/src/components/interfaces';
import { useCTranslations } from '@/src/infrastructure/provider';

export enum CFieldSecurity {
  Encrypted = 'encrypted',
  Public = 'public',
}

export interface CFieldLabelProps {
  htmlFor?: string;
  formId?: string;
  label: string;
  required?: boolean;
  security?: CFieldSecurity;
  securityTooltip?: string;
  class?: string;
  hasValue?: boolean;
  onClick?: () => void;  hasPlaceholder?: boolean;
}

export function CFieldLabel(props: CFieldLabelProps): React.JSX.Element {
  const translations = useCTranslations();
  const securityIcon = props.security === CFieldSecurity.Encrypted ? CIcons.Shield : CIcons.ShieldOff;
  const securityColor = props.security === CFieldSecurity.Encrypted ? CIconColor.Success : CIconColor.Error;
  const defaultTooltip = props.security === CFieldSecurity.Encrypted
    ? translations.security.encrypted
    : translations.security.public;

  return (
    <CFlex alignItems={AlignItems.Center} class={classNames('c-field-label', props.class)} columnGap={CSpacing.Sm}>
      <label
        htmlFor={props.htmlFor}
        onClick={props.onClick}
        form={props.formId}
        className={classNames('c-field__label', {
          'c-field__label--value': props.hasValue,
          'c-field__label--placeholder': props.hasPlaceholder,
        })}
        data-test-selector="field-label"
      >
        {`${props.label} ${props.required ? '*' : ''}`.trim()}
      </label>
      {props.security && (
        <CTooltip content={props.securityTooltip ?? defaultTooltip} placement={CTooltipPlacement.Top}>
          <CIcon
            icon={securityIcon}
            size={CIconSize.Md}
            color={securityColor}
            class="c-field-label__security-icon"
          />
        </CTooltip>
      )}
    </CFlex>
  );
}
